import { ErrorType } from '../../models/HttpError';
import {
    AgingBucketStatisticViewModel,
    CashflowSeriesPointViewModel,
    DebtSeriesPointViewModel,
    MonthlyCashflowStatisticViewModel,
    OverviewStatisticViewModel,
    PaymentDelaySeriesPointViewModel,
    PaymentDelayStatisticViewModel,
    TopEntityStatisticViewModel
} from '../../models/Entities/CashFlow/Statistics/StatisticsModels';

interface SliceStatus {
    isLoading: boolean;
    success: boolean | undefined;
    failed: boolean;
}

export interface CashFlowStatisticsState {
    // KPIs
    overview: OverviewStatisticViewModel[];
    overviewStatus: SliceStatus;

    paymentDelay: PaymentDelayStatisticViewModel[];
    paymentDelayStatus: SliceStatus;

    monthlyCashflow: MonthlyCashflowStatisticViewModel[];
    monthlyCashflowStatus: SliceStatus;

    topDebtors: TopEntityStatisticViewModel[];
    topDebtorsStatus: SliceStatus;

    topCreditors: TopEntityStatisticViewModel[];
    topCreditorsStatus: SliceStatus;

    aging: AgingBucketStatisticViewModel[];
    agingStatus: SliceStatus;

    // Time series
    cashflowSeries: CashflowSeriesPointViewModel[];
    cashflowSeriesStatus: SliceStatus;

    debtSeries: DebtSeriesPointViewModel[];
    debtSeriesStatus: SliceStatus;

    paymentDelaySeries: PaymentDelaySeriesPointViewModel[];
    paymentDelaySeriesStatus: SliceStatus;

    error: ErrorType | undefined;
}

const emptyStatus: SliceStatus = {
    isLoading: false,
    success: undefined,
    failed: false
};

export const CashFlowStatisticsUnloadState: CashFlowStatisticsState = {
    overview: [],
    overviewStatus: { ...emptyStatus },

    paymentDelay: [],
    paymentDelayStatus: { ...emptyStatus },

    monthlyCashflow: [],
    monthlyCashflowStatus: { ...emptyStatus },

    topDebtors: [],
    topDebtorsStatus: { ...emptyStatus },

    topCreditors: [],
    topCreditorsStatus: { ...emptyStatus },

    aging: [],
    agingStatus: { ...emptyStatus },

    cashflowSeries: [],
    cashflowSeriesStatus: { ...emptyStatus },

    debtSeries: [],
    debtSeriesStatus: { ...emptyStatus },

    paymentDelaySeries: [],
    paymentDelaySeriesStatus: { ...emptyStatus },

    error: undefined
};
